/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Flight configuration for StackAdapt campaign group
*/
export class V3StackAdaptFlight {
    /**
    * Flight ID
    */
    'id'?: string;
    /**
    * Daily budget for the flight
    */
    'dailyBudget'?: number;
    /**
    * End time for the flight
    */
    'endTime'?: string;
    /**
    * Whether to pace evenly
    */
    'isPaceEvenly'?: boolean;
    /**
    * Lifetime budget for the flight
    */
    'lifetimeBudget'?: number;
    /**
    * Start time for the flight
    */
    'startTime'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "dailyBudget",
            "baseName": "dailyBudget",
            "type": "number",
            "format": "float"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "isPaceEvenly",
            "baseName": "isPaceEvenly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "lifetimeBudget",
            "baseName": "lifetimeBudget",
            "type": "number",
            "format": "float"
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptFlight.attributeTypeMap;
    }

    public constructor() {
    }
}

